/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const applicantFiltersDataSchema = z.object({})

export type ApplicantFiltersDataSchema = z.infer<typeof applicantFiltersDataSchema>
